/** Tells the Home page (and anything else showing nearby results) that the home area was just saved. */
const EVENT = 'gdc:home-area-changed';

export const notifyHomeAreaChanged = (): void => {
  window.dispatchEvent(new Event(EVENT));
};

/** Subscribe; returns the unsubscribe function. */
export const onHomeAreaChanged = (handler: () => void): (() => void) => {
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
};
